<template>
  <!-- 底部导航栏 -->
  <div class="bottom-nav">
    <div class="box">
      <div class="top">
        <div class="list">
          <div class="item" v-for="item in serverList" :key="item.id">
            <img :src="item.logo" alt="" />
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div class="center">
        <div class="list">
          <div class="item" v-for="item in routerList" :key="item.id">
            <div class="title">{{ item.title }}</div>
            <router-link v-for="i in item.children" :key="i.id" :to="i.path">
              <div class="children">{{ i.title }}</div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div>Copyright © {{ year }} 上海畅居智慧信息技术有限公司版权所有</div>
        <a href="https://beian.miit.gov.cn" target="_blank"
          >备案号：沪ICP备2021034369号-1</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import CQcode from "../../../assets/home/CQcode.jpg";

import serveLogo1 from "../../../assets/home/serveLogo1.png";
import serveLogo2 from "../../../assets/home/serveLogo2.png";
import serveLogo3 from "../../../assets/home/serveLogo3.png";
import serveLogo4 from "../../../assets/home/serveLogo4.png";
import serveLogo5 from "../../../assets/home/serveLogo5.png";

export default {
  setup() {
    return reactive({
      year: new Date().getFullYear(),
      CQcode: CQcode,
      serverList: [
        {
          id: 1,
          title: "免费试用",
          logo: serveLogo1,
        },
        {
          id: 2,
          title: "售前评估",
          logo: serveLogo2,
        },
        {
          id: 3,
          title: "快速上线",
          logo: serveLogo3,
        },
        {
          id: 4,
          title: "1v1大客户服务",
          logo: serveLogo4,
        },
        {
          id: 5,
          title: "5天无理由退款",
          logo: serveLogo5,
        },
      ],
      routerList: [
        {
          id: 1,
          title: "产品体系",
          children: [
            {
              id: 1,
              title: "畅月数字家园管理系统",
              path: "/mobile/product/adminsystem",
            },
            {
              id: 2,
              title: "物联网平台",
              path: "/mobile/product/things",
            },
          ],
        },
        {
          id: 2,
          title: "移动应用",
          children: [
            {
              id: 1,
              title: "物业APP",
              path: "/mobile/product/property",
            },
            {
              id: 2,
              title: "居民APP",
              path: "/mobile/product/resident",
            },
            {
              id: 3,
              title: "居民小程序",
              path: "/mobile/product/resident",
            },
          ],
        },
        {
          id: 3,
          title: "物联网",
          children: [
            {
              id: 1,
              title: "智能监控",
              path: "/mobile/programme/monitor",
            },
            {
              id: 2,
              title: "智能门禁",
              path: "/mobile/programme/accesscontrol",
            },
            {
              id: 3,
              title: "智能能耗",
              // path: "/mobile/programme/energyconsumption",
              path: "",
            },
            {
              id: 4,
              title: "智能梯控",
              path: "/mobile/programme/laddercontrol",
            },
            {
              id: 5,
              title: "智能充电",
              path: "/mobile/programme/charge",
            },
            {
              id: 6,
              title: "智能停车",
              path: "/mobile/programme/parking",
            },
          ],
        },
        {
          id: 4,
          title: "解决方案",
          children: [
            {
              id: 1,
              title: "智慧社区",
              path: "/mobile/programme/community",
            },
            {
              id: 2,
              title: "社区管理",
              path: "/mobile/programme/communityadmin",
            },
            {
              id: 4,
              title: "智慧安防",
              path: "/mobile/programme/security",
            },
            {
              id: 5,
              title: "财务管理",
              // path: "/mobile/programme/financeadmin",
              path: "",
            },
            {
              id: 6,
              title: "智慧商圈",
              // path: "/mobile/programme/businessdistrict",
              path: "",
            },
          ],
        },
        {
          id: 5,
          title: "关于我们",
          children: [
            {
              id: 1,
              title: "公司简介",
              path: "/mobile/about",
            },
            {
              id: 2,
              title: "公司历程",
              path: "/mobile/about",
            },
            {
              id: 3,
              title: "组织结构",
              path: "/mobile/about",
            },
            {
              id: 4,
              title: "公司资历",
              path: "/mobile/about",
            },
            {
              id: 5,
              title: "企业文化",
              path: "/mobile/about",
            },
          ],
        },
        {
          id: 6,
          title: "联系我们",
          children: [
            {
              id: 1,
              title: "021-5916-6882",
              path: "/mobile/contact",
            },
          ],
        },
      ],
    });
  },
};
</script>

<style scoped>
.bottom-nav {
  background: rgba(243, 244, 248, 0.4);
}
.box {
  width: 92vw;
  margin: 0 auto 0;
  padding-top: 16px;
}
.top {
  padding-bottom: 16px;
  border-bottom: 1px solid #dce1e8;
}
.top .list {
  width: 92vw;
  margin: 0 auto;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
}
.top .list .item {
  width: 90px;
  font-size: 13px;
  text-align: center;
  margin-bottom: 20px;
}
.top .list .item img {
  width: 32px;
}

.center {
  margin-top: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #dce1e8;
  text-align: center;
}
.center .list {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.center .list .item  {
  width: 120px;
  margin-bottom: 32px;
}
.center .list .item .title {
  font-size: 14px;
  margin-bottom: 8px;
}
.center .list .item .children {
  font-size: 12px;
  color: #495A6C;
  margin-bottom: 8px;
}
.CQcode {
  width: 180px;
}

.bottom {
  margin-top: 24px;
  padding-bottom: 30px;
  text-align: center;
}
.bottom div,
.bottom a {
  font-size: 8px;
  color: #495a6c;
  margin-bottom: 8px;
}
a {
  text-decoration: none;
}
a:hover {
  color: #248efb;
}
.center .list .item .children:hover {
  color: #248efb;
}
</style>
